<!--
<ons-button modifier="quiet" (click)="logout()">Logout</ons-button>
-->
<div class="left" style="margin:10px;">
  <ons-toolbar-button icon="md-lock" (click)="logout()"></ons-toolbar-button>
</div>
